export default "__VITE_ASSET__BcaEUfgD__"